module.exports = __webpack_public_path__ + "664d31bb3962d5e9b7f45086a1f04a38.png";